import api from "./client";

export interface Project {
  id: string;
  organization_id: string;
  name: string;
  description?: string;
  is_archived: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreateProjectData {
  name: string;
  description?: string;
  provider?: string; // Azure, AWS, GCP
  settings?: any;
}

export interface UpdateProjectData {
  name?: string;
  description?: string;
}

export async function getProjects(): Promise<Project[]> {
  const response = await api.get("/api/projects");
  // L'API retourne { projects: [...] }
  return response.data.projects || response.data;
}

export async function getProject(id: string): Promise<Project> {
  const response = await api.get(`/api/projects/${id}`);
  // L'API retourne { project: {...} }
  return response.data.project || response.data;
}

export async function createProject(data: CreateProjectData): Promise<Project> {
  const response = await api.post("/api/projects", data);
  // L'API retourne { message: "...", project: {...} }
  return response.data.project || response.data;
}

export async function updateProject(id: string, data: UpdateProjectData): Promise<Project> {
  const response = await api.patch(`/api/projects/${id}`, data);
  // L'API retourne { message: "...", project: {...} }
  return response.data.project || response.data;
}

export async function archiveProject(id: string): Promise<void> {
  await api.post(`/api/projects/${id}/archive`);
}

export async function deleteProject(id: string): Promise<void> {
  await api.delete(`/api/projects/${id}`);
}
